'use client';
import { useTranslations, useLocale } from 'next-intl';
import ArrowIcon from '@/components/ui/icons/arrow-icon';
import { useState } from 'react';
import Modal from '@/components/ui/modals';
import StoreLocatorModal from '@/components/ui/modals/store-locator-modal';
import { event_button_click } from '@/utils/gtm';
const FindStore = ({ entity_id }) => {
  const t = useTranslations('product');
  const locale = useLocale();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className='rounded-lg bg-blue-50 p-3 transition-shadow hover:shadow-md sm:-mt-2'>
      <div className='flex items-center justify-between'>
        <div className='flex items-start gap-2'>
          <div className='mt-0.5 flex-shrink-0 text-blue-600'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M19 7H5C3.89543 7 3 7.89543 3 9V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7Z'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M16 7V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V7'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M12 12V15'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M16 12V15'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M8 12V15'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
            </svg>
          </div>
          <div className='flex-1'>
            <div className='text-sm font-medium'>
              {t('Want to buy this in Person')}
            </div>
            <div className='text-xs text-gray-600'>
              {t('Find the nearest innova Pharmacy')}
            </div>
          </div>
        </div>
        <button
          onClick={() => {
            event_button_click({
              button_name: 'Find Store',
              button_destination: 'open_store_locator',
              button_location: 'pdp',
            });
            setIsModalOpen(true);
          }}
          className='flex items-center gap-1 rounded-md bg-blue-600 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-blue-700'
        >
          {t('find_store')}
          <ArrowIcon
            size={14}
            className={`${locale === 'en' ? 'rotate-270' : 'rotate-90'}`}
          />
        </button>
      </div>

      {isModalOpen && (
        <Modal
          maxWidth='max-w-11/12 lg:max-w-2xl'
          isOpen={true}
          onClose={() => {
            setIsModalOpen(false);
          }}
          headerTitleClassName='max-lg:!p-2 !px-4 !py-3 max-lg:text-sm'
          title={t('nearest_pharmacy')}
        >
          <StoreLocatorModal {...{ entity_id }} />
        </Modal>
      )}
    </div>
  );
};

export default FindStore;
